import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon, PhoneIcon } from 'lucide-react';
import { Button } from './ui/Button';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Home',
    href: '#'
  }, {
    name: 'Services',
    href: '#services'
  }, {
    name: 'Service Areas',
    href: '#areas'
  }, {
    name: 'Reviews',
    href: '#reviews'
  }, {
    name: 'Before & After',
    href: '#gallery'
  }, {
    name: 'Contact',
    href: '#contact'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-200 bg-white ${isScrolled ? 'shadow-md py-2' : 'py-4'}`} data-id="element-43">
      <div className="container mx-auto px-4 max-w-7xl" data-id="element-44">
        <div className="flex items-center justify-between h-[60px] md:h-auto" data-id="element-45">
          {/* Logo */}
          <a href="#" className="z-50 flex-shrink-0" data-id="element-46">
            <img src="https://cdn.magicpatterns.com/uploads/8v3zFjXb1ztSvnWk7Sday7/PTCC_Logo-01.png" alt="Phoenix Tile & Carpet Cleaning" className="h-10 md:h-14 w-auto" data-id="element-47" />
          </a>

          {/* Desktop Nav */}
          <nav className="hidden lg:flex items-center gap-6" data-id="element-48">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-medium text-navy hover:text-red transition-colors" data-id="element-49">
                {link.name}
              </a>)}
            <Button variant="primary" size="sm" className="ml-4 min-h-[44px]" data-id="element-50">
              Book Online
            </Button>
          </nav>

          {/* Mobile Menu Toggle */}
          <button className="lg:hidden p-2 text-navy z-50 min-h-[44px] min-w-[44px] flex items-center justify-center" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-51">
            {isMobileMenuOpen ? <XIcon size={28} data-id="element-52" /> : <MenuIcon size={28} data-id="element-53" />}
          </button>
        </div>
      </div>

      {/* Mobile Nav Overlay */}
      <div className={`fixed inset-0 bg-white z-40 transition-transform duration-300 ease-in-out lg:hidden pt-[80px] ${isMobileMenuOpen ? 'translate-x-0' : 'translate-x-full'}`} data-id="element-54">
        <nav className="flex flex-col items-center gap-6 p-6 h-full overflow-y-auto" data-id="element-55">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-xl font-semibold text-navy w-full text-center py-3 border-b border-gray-100" onClick={() => setIsMobileMenuOpen(false)} data-id="element-56">
              {link.name}
            </a>)}
          <div className="mt-8 w-full flex flex-col gap-4" data-id="element-57">
            <Button variant="primary" fullWidth size="lg" data-id="element-58">
              Book Online
            </Button>
            <a href="tel:6029351141" className="flex items-center justify-center gap-2 text-navy font-bold text-lg py-4" data-id="element-59">
              <PhoneIcon size={20} data-id="element-60" />
              (602) 935-1141
            </a>
          </div>
        </nav>
      </div>
    </header>;
}